<template>
  <div>
    <div style="width: 300px">
      <el-input v-model="keyword" placeholder="输入关键字，搜索文档" @keyup.enter.native="search">
        <template slot="append">
          <el-button type="primary" @click="search" id="clickSearch"><i class="el-icon-search" id="searchIcon"></i>
          </el-button>
        </template>
      </el-input>
    </div>
    <div style="width: 300px" class="angle-wrapper" v-if="showResult" @click="closeSearch" ref="searchContainer">
      <ul v-if="showResult&&searchResults.length>0" class="dropdown-list">
        <li v-for="(item, index) in searchResults" :key="index" @click="confirmTo(item)">
          <span v-html="highlightedText(item)"></span>
        </li>
      </ul>
      <ul v-if="showResult&&searchResults.length===0" class="dropdown-list">
        <li>
          <span>暂无匹配结果</span>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import {modelIntroCon} from "@/utils/notes";

export default {
  props: ['menuList'],
  data() {
    return {
      keyword: '',
      showResult: false,
      searchResults: [],
      keywordOld: ''
    };
  },
  mounted() {
    window.addEventListener("click", this.onWindowClick);
  },
  methods: {
    //点击搜索
    search() {
      this.showResult = true;
      if (this.keyword) {
        this.searchResults = this.findValueByKeyword(this.keyword);
      } else {
        this.searchResults = []
      }
    },
    //根据关键字搜索
    findValueByKeyword(keyword) {
      this.keywordOld = JSON.parse(JSON.stringify(this.keyword))
      let results = [];
      const data = modelIntroCon
      let dataValue = Object.values(data)
      let dataKey = Object.keys(data)
      for (let i = 0; i < dataValue.length; i++) {
        let value = dataValue[i]
        if (value.includes(keyword)) {
          let matchArr=this.findMatches(value,keyword)
          matchArr.map(index=>{
            let start = index >= 10 ? index - 10 : 0
            let end = (index + 10) > value.length ? value.length : index + 10
            let res = value.substring(start, end)
            let res1 = (start === 0 ? '' : '...') + res + (end === value.length - 1 ? '...' : '')
            results.push({
              key:dataKey.find(key => data[key] === value),
              value:res1
            })
          })
        }
      }
      return results;
    },

    // 返回能匹配的位置
    findMatches(str, pattern) {
      let regex = new RegExp(pattern, 'g');
      let matches = [];
      let match;
      while ((match = regex.exec(str)) !== null) {
        matches.push(match.index);
      }
      return matches;
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    //让搜索结果的关键字高亮显示
    highlightedText(obj) {
      let text = obj.value
      let keyWord = JSON.parse(JSON.stringify(this.keywordOld))
      let index = text.indexOf(keyWord)
      let length = keyWord.length
      const res = text.substring(0, index) + `<span class="highlight">${keyWord}</span>` + text.substring(index + length)
      return res
    },
    //点击搜索结果中的内容
    confirmTo(item) {
      this.showResult = false
      this.menuList.map(parent=>{
        if(parent.sons.length>0){
          parent.sons.map(son => {
            if (son.path.includes(item.key)) {
              this.$emit('handleNodeClick', parent, son)
            }
          })
        }else {
          if (parent.path.includes(item.key)) {
            this.$emit('handleNodeClick', parent, '')
          }
        }
      })
    },
    //关闭搜索框
    closeSearch() {
      this.showResult = false;
    },
    onWindowClick(event) {
      if (this.showResult) {
        if ((!this.$refs.searchContainer.contains(event.target)) && event.target.id !== 'clickSearch' && event.target.id !== 'searchIcon') {
          this.closeSearch();
        }
      }
    }
  },
};
</script>

<style scoped>
/deep/ .highlight {
  background-color: yellow !important;
}

.dropdown-list {
  z-index: 99;
  position: absolute;
  list-style-type: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  max-height: 300px;
  overflow-y: auto;
  width: 300px;
  border: 1px solid #f2f2f2;
}

.dropdown-list li {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
  font-size: 15px;
}

.dropdown-list li:hover {
  background-color: #f2f2f2;
}

/deep/ .el-input-group__append {
  color: #1e6cb0;
  background-color: #deeaf1;
}

.angle-wrapper {
  width: 300px;
  position: relative;
  background: rgb(255, 255, 255);
  margin-top: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.angle-wrapper:before {
  content: "";
  width: 0;
  height: 0;
  border: 10px solid transparent;
  /*border: 10px solid transparent;*/
  border-bottom-color: rgb(255, 255, 255);
  position: absolute;
  right: 50%;
  /*top: 50%;*/
  margin-top: -20px;
}

</style>
